import { createContext, useContext } from "react";
import type { DataGridCellAddr } from "./types";

type DataGridNavigation = {
	matrix: DataGridCellAddr[][];
	/** First navigable row outside the sticky header block. Pinned rows lead the matrix but never
	 *  scroll, so this, not `matrix[0]`, is the row whose focus returns the grid to the top. */
	firstScrollingRowId: string | undefined;
	gridTemplate: string;
};

export const DataGridNavContext = createContext<DataGridNavigation | null>(null);

export const useDataGridNavigation = (): DataGridNavigation => {
	const ctx = useContext(DataGridNavContext);
	if (!ctx) throw new Error("useDataGridNavigation must be used inside DataGrid");
	return ctx;
};

/** Returns the CSS grid-template-columns string computed by DataGrid.
 *  Use this inside renderCells components that need to match the grid layout. */
export const useDataGridGridTemplate = (): string => useDataGridNavigation().gridTemplate;
